"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestManager = exports.createShareRefreshing = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
require("./types");
function createShareRefreshing() {
    let resource = null;
    return (fn) => {
        if (resource) {
            return resource;
        }
        resource = fn().pipe(operators_1.tap(() => {
            resource = null;
        }), operators_1.catchError((err) => {
            resource = null;
            throw err;
        }), operators_1.share());
        return resource;
    };
}
exports.createShareRefreshing = createShareRefreshing;
function isNeedRetryDefault(err) {
    return err.status === 503;
}
function getDefault(option, defaultValue) {
    return option === 0 ? 0 : option || defaultValue;
}
function getDefaultFn(option, defaultValue) {
    return typeof option === 'function' ? option : defaultValue;
}
class RequestManager {
    constructor(token, shareRefreshing, retryOptions = {}) {
        this.run = (task) => {
            if (typeof task !== 'function') {
                throw new Error('RequestManager error: bad arguments');
            }
            const runTask = () => {
                try {
                    const stream = task();
                    if (!stream && stream !== 0) {
                        return rxjs_1.throwError(new Error('RequestManager error: bad return value from task'));
                    }
                    return rxjs_1.from(stream);
                }
                catch (err) {
                    return rxjs_1.throwError(err);
                }
            };
            return rxjs_1.Observable.create((observer) => observer.next(runTask())).pipe(operators_1.switchMap((v) => v), operators_1.retryWhen((attempts) => attempts.pipe(operators_1.zip(rxjs_1.range(1, 2)), operators_1.flatMap(([error, count]) => {
                if (count > 1) {
                    return rxjs_1.throwError(error);
                }
                if (error.status === 401) {
                    return rxjs_1.from(this.token.hasToken()).pipe(operators_1.switchMap((hasToken) => {
                        if (hasToken) {
                            return this.shareRefreshing(() => rxjs_1.from(this.token.refresh()).pipe(operators_1.catchError((err) => {
                                this.token.clear();
                                err.status = 401; // eslint-disable-line no-param-reassign
                                return rxjs_1.throwError(err);
                            }))).pipe(operators_1.take(1));
                        }
                        return rxjs_1.throwError(error);
                    }));
                }
                return rxjs_1.throwError(error);
            }))), operators_1.retryWhen((attempts) => attempts.pipe(operators_1.zip(rxjs_1.range(1, this.retryOptions.retryCount)), operators_1.flatMap(([error, count]) => {
                if (count > 3) {
                    return rxjs_1.throwError(error);
                }
                if (count === this.retryOptions.retryCount &&
                    this.retryOptions.reloadAfterMaxCountReached) {
                    window.location.reload();
                }
                if (this.retryOptions.isNeedRetry(error)) {
                    return rxjs_1.timer(count * this.retryOptions.timeout);
                }
                return rxjs_1.throwError(error);
            }))));
        };
        this.token = token;
        this.shareRefreshing = shareRefreshing || createShareRefreshing();
        this.retryOptions = {
            isNeedRetry: getDefaultFn(retryOptions.isNeedRetry, isNeedRetryDefault),
            retryCount: getDefault(retryOptions.retryCount, 3),
            timeout: getDefault(retryOptions.timeout, 1000),
            reloadAfterMaxCountReached: !!retryOptions.reloadAfterMaxCountReached,
        };
    }
}
exports.RequestManager = RequestManager;
//# sourceMappingURL=RequestManager.js.map